<template>
  <div class="ranking-question">
    <div class="table-responsive">
      <table class="table table-sm table-borderless align-middle mb-0">
        <thead>
          <tr>
            <th class="text-muted fw-semibold">Option</th>
            <th class="text-muted fw-semibold ranking-rank-col">Rank</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="option in options" :key="option">
            <td>
              <span class="ranking-option-text">{{ option }}</span>
            </td>
            <td class="ranking-rank-col">
              <select
                class="form-select form-select-sm"
                :value="getRankValue(option)"
                :disabled="disabled"
                @change="onRankChange(option, $event.target.value)"
              >
                <option value="">Not ranked</option>
                <option v-for="rank in rankValues" :key="rank" :value="rank">
                  {{ rank }}
                </option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <small class="text-muted d-block mt-2">
      You may rank some or all options. Each rank can only be used once.
    </small>
  </div>
</template>

<script>
export default {
  name: 'RankingQuestion',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    rankValues() {
      return Array.from({ length: this.options.length }, (_, index) => index + 1)
    },
    normalizedValue() {
      const normalized = {}
      const maxRank = this.options.length

      this.options.forEach(option => {
        const rawValue = this.modelValue?.[option]
        const parsed = Number.parseInt(rawValue, 10)

        if (Number.isInteger(parsed) && parsed >= 1 && parsed <= maxRank) {
          normalized[option] = parsed
        }
      })

      return normalized
    }
  },
  methods: {
    getRankValue(option) {
      return this.normalizedValue[option] ?? ''
    },
    onRankChange(option, newValue) {
      const nextValue = { ...this.normalizedValue }
      const parsedRank = Number.parseInt(newValue, 10)

      if (!newValue || !Number.isInteger(parsedRank)) {
        delete nextValue[option]
        this.$emit('update:modelValue', nextValue)
        return
      }

      Object.keys(nextValue).forEach(existingOption => {
        if (existingOption !== option && nextValue[existingOption] === parsedRank) {
          delete nextValue[existingOption]
        }
      })

      nextValue[option] = parsedRank
      this.$emit('update:modelValue', nextValue)
    }
  }
}
</script>

<style scoped>
.ranking-rank-col {
  width: 140px;
}

.ranking-option-text {
  display: inline-block;
  line-height: var(--line-height-normal);
}
</style>
